<template>
    <div class="orderdetails_content">
        <div class="orderdetails_head_content">
            <table>
                <colgroup>
                    <col width="11.5873%">
                    <col width="21.746%">
                    <col width="11.5873%">
                    <col width="21.746%">
                    <col width="11.5873%">
                    <col width="21.746%">
                </colgroup>
                <tbody>
                    <tr>
                        <th><span>订单号：</span></th>
                        <td><span>{{orderinfo.rebackdno}}</span></td>
                        <th><span>订单状态：</span></th>
                        <td><span :style="{color: orderinfo.status != 4 && orderinfo.status != 5 && orderinfo.status != 6 ? '#FF8000' : ''}">{{orderinfo.statusname}}</span></td>
                        <th><span>退货单金额：</span></th>
                        <td><span>￥{{orderinfo.rebackallcost}}</span></td>
                    </tr>
                    <tr>
                        <th><span>订单时间：</span></th>
                        <td><span>{{orderinfo.addtime}}</span></td>
                        <th v-if="orderinfo.closereason != null"><span>取消原因：</span></th>
                        <td v-if="orderinfo.closereason != null"><span>{{orderinfo.closereason}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="orderdetails_box">
            <div class="shoppingcart_head_check_content">
                <div class="shoppingcart_head_check_left">
                    <RadioGroup v-model="sort" size="large">
                        <Radio :label=1>按下单时间排序</Radio>
                        <Radio :label=2>按商品编号排序</Radio>
                    </RadioGroup>
                </div>
                <div class="shoppingcart_head_check_right" v-if="orderinfo.status == 1">
                    <Button type="warning" @click="confirmClick">确认发货</Button>
                </div>
            </div>
            <div class="orderdetails_table_content pad0">
                <Table
                    border
                    ref="selection"
                    :columns="thead"
                    :data="goodslist"></Table>
            </div>
            <div class="orderdetails_orderprice">
                <span>商品金额：</span><small>{{orderinfo.rebackallgoodscost}}元</small>
            </div>
        </div>
        <div class="h6"></div>
        <div class="orderdetails_info_content">
            <div class="goods_details_bottom_content">
                <Tabs>
                    <TabPane label="订单信息">
                        <div class="orderdetails_info_list">
                            <ul>
                                <li>
                                    <div class="orderdetails_info_left"><span class="letter">备注：</span></div>
                                    <div class="orderdetails_info_right"><span>{{orderinfo.reason}}</span></div>
                                </li>
                                <li v-if="orderinfo.status > 1 && orderinfo.status != 5">
                                    <div class="orderdetails_info_left"><span>物流信息：</span></div>
                                    <div class="orderdetails_info_right"><span><i class="icon iconfont icon-bianji edit" @click="reviselogistics" v-if="orderinfo.status < 3"></i>（物流公司）{{orderinfo.returnfirm}}，（物流单号）{{orderinfo.returnodd}}，（发货日期）{{orderinfo.sendtime}}</span></div>
                                </li>
                                <li>
                                    <div class="orderdetails_info_left"><span class="letter">附件：</span></div>
                                    <div class="orderdetails_info_right">
                                        <div class="uploadfile_content">
                                            <small v-if="orderinfo.status == 0">（请上传图片，最多5张，单张大小不超过6M，支持格式：PDF,WORD,EXCEL,TXT,JPG,JPEG,PNG,GIF,RAR,ZIP）</small>
                                            <small v-else>当前状态不能上传附件</small>
                                            <Upload
                                                ref="upload"
                                                :disabled="orderinfo.status != 0"
                                                :action="action"
                                                :show-upload-list="false"
                                                :default-file-list="defaultList"
                                                :multiple="true"
                                                :format="['pdf','word', 'doc', 'excel','txt','jpg','jpeg','png','gif','rar','zip']"
                                                accept=".pdf, .word, .doc, .excel, .txt, .jpg, .jpeg, .png, .gif, .rar, .zip"
                                                name="imgFile"
                                                :max-size="filemaxsize"
                                                :before-upload="uploadBefore"
                                                :on-progress="uploadProgress"
                                                :on-success="uploadSuccess"
                                                :on-error="uploadError"
                                                :on-remove="uploadRemove"
                                                :on-exceeded-size="uploadExceededSize"
                                            >
                                                <Button class="uploadfile_btn">选择文件</Button>
                                            </Upload>
                                            <div class="uploadfile_list">
                                                <ul>
                                                    <li v-for="(item, index) in uploadList" :key="index">
                                                        <template v-if="item.status === 'finished'">
                                                            <span>{{item.name}}</span>
                                                            <a :href="item.url" target="_blank">查看</a>
                                                            <a href="javascript:;" @click="deluploadfile(item.url)">删除</a>
                                                        </template>
                                                        <template v-else>
                                                            <div style="width: 260px;">
                                                                <Progress v-if="item.showProgress" :percent="item.percentage"></Progress>
                                                            </div>
                                                        </template>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        </div>
        <!-- 确认发货 -->
        <DeliverGoods :delivergoodsShow="delivergoodsShow" :delivergoodsInfo="delivergoodsInfo" @delivergoodsOk="delivergoodsOk" @delivergoodsCancel="delivergoodsCancel"></DeliverGoods>
    </div>
</template>

<script>
import api from '@/request/api.js'
import {toMoney} from '@/filter/moneyFilter.js'
import DeliverGoods from '@/components/component/popup/delivergoods.vue'
export default {
    components: {DeliverGoods},
    data() {
        return {
            delivergoodsShow: false, // 确认发货弹窗是否显示
            delivergoodsInfo: { // 确认发货弹窗信息
                sendtime: '',
                returnfirm: '',
                returnodd: '',
            },
            orderinfo: {}, // 订单信息
            confirmrevise: true, // 判断是确认收货还是修改物流信息 true 确认 false 修改
            thead: [ // 表格头部
                {
                    type: 'index',
                    width: 50,
                    align: 'center',
                },
                {
                    width: 320,
                    align: 'center',
                    title: '商品',
                    key: 'goods',
                    render: (h, params) => {
                        return h('div', // 商品
                                    [
                                        h('div', // 商品图片
                                            {
                                                class: 'shoppingcart_goods_left',
                                                style: {
                                                    backgroundImage: 'url(' + params.row.goodsimg + ')'
                                                }
                                            }
                                        ),
                                        h('div', // 商品右侧信息
                                            {
                                                class: 'shoppingcart_goods_right'
                                            },
                                            [   
                                                h('Poptip',
                                                    {
                                                        props: {
                                                            trigger: 'hover',
                                                            width: '246',
                                                            wordWrap: true,
                                                            content: params.row.goodsname
                                                        }
                                                    },
                                                    [
                                                        h('span', // 商品名称
                                                            {
                                                                class: 'shoppingcart_goods_name'
                                                            },
                                                            [
                                                                h('b',
                                                                    {
                                                                        style: {
                                                                            backgroundColor: params.row.cxtype == 1 ? '#FF8000' : '#40a250',
                                                                            display: params.row.cxtype == 1 || params.row.cxtype == 2 ? 'inline' : 'none'
                                                                        }
                                                                    },
                                                                    params.row.cxtype == 1 ? '特价' : (params.row.cxtype == 2 ? '折扣' : '')
                                                                ),
                                                                h('b', {style: {
                                                                            backgroundColor: params.row.is_send == 1 ? '#FF8000' : '',
                                                                            display: params.row.is_send == 1 ? 'inline' : 'none'
                                                                        }
                                                                    },
                                                                    params.row.is_send == 1 ? '赠品' : ''
                                                                ),
                                                                h('span', params.row.goodsname)
                                                            ]
                                                        ),
                                                    ]
                                                ),
                                                h('small', // 商品编号
                                                    '商品编号：' + params.row.commcode
                                                )
                                            ]
                                        ),
                                    ]
                                )
                    }
                },
                {
                    align: 'center',
                    title: '规格',
                    key: 'gg_attrname'
                },
                {
                    align: 'center',
                    title: '单位',
                    key: 'goodsdanwei',
                    render: (h, params) => {
                        return h('span', params.row.unit)
                    }
                },
                {
                    align: 'center',
                    title: '退货数',
                    key: 'rebacknum'
                },
                {
                    align: 'center',
                    title: '单价',
                    key: 'rebackgoodscost',
                    render: (h, params) => {
                        if (params.row.is_send == 1) return h('del', params.row.rebackgoodscost)
                        if (params.row.is_send == 0) return h('span', params.row.rebackgoodscost)
                    }
                },
                {
                    align: 'center',
                    title: '小计',
                    key: 'subtotal',
                    render: (h, params) => {
                        if (params.row.is_send == 1) return h('span', '0.00')
                        if (params.row.is_send == 0) return h('span', (params.row.rebacknum * params.row.rebackgoodscost).toFixed(2))
                    }
                },
                {
                    align: 'center',
                    title: '关联单号',
                    key: 'num',
                    render: (h, params) => {
                        return h('span',
                                    {
                                        style: {
                                            color: this.orderinfo.relatedorder == 1 ? '#0c1f6d' : '',
                                            cursor: this.orderinfo.relatedorder == 1 ? 'pointer' : '',
                                        },
                                        on: {
                                            click: () => {
                                                this.jumporderdetails(params.row.order_id)
                                            }
                                        },
                                    },
                                    this.orderinfo.orderdno
                                )
                    }
                },
            ],
            goodslist: [], // 表格列表
            action: this.getWebsite() + api.returnupload + this.getCookie('cook_ShopId') + '&cus_uid=' + this.getCookie('cook_cus_uid') + '&cus_pwd=' + this.getCookie('cook_cus_pwd') + '&orderid=' + this.$route.params.id, // 上传文件地址
            sort: 1, // 排序方式 1 按下单排序 2 按商品编号排序
            filemaxsize: Math.pow(4, 6), // 文件大小限制
            defaultList: [], // 默认上传文件列表
            uploadList: [], // 显示已上传列表
        }
    },
    methods: {
        getInfo () { // 获取订单信息
            this.http.post(api.returndetails, {id: this.$route.params.id, sorttype: this.sort})
            .then(response => {
                console.log(response.data.msg)
                console.log(response.data.msg.rebackorder_oneorder.det)
                this.orderinfo = response.data.msg.rebackorder_oneorder
                this.goodslist = response.data.msg.rebackorder_oneorder.det
                if (response.data.msg.rebackorder_oneorder.filearr != null) {
                    for (var i = 0; i < response.data.msg.rebackorder_oneorder.filearr.length; i++) {
                        response.data.msg.rebackorder_oneorder.filearr[i].percentage = 100
                        response.data.msg.rebackorder_oneorder.filearr[i].status = "finished"
                    }
                    this.uploadList = response.data.msg.rebackorder_oneorder.filearr
                }
            })
            .catch(error => {
                this.$Message.warning(error);
            })
        },
        jumporderdetails (id) { // 关联订单号 跳转订单详情
            if (this.orderinfo.relatedorder == 1) {
                this.$router.push({
                    name: '订货详情',
                    params: {
                        id: id
                    }
                })
            }
        },
        confirmClick () { // 确认发货弹窗
            this.confirmrevise = true
            this.delivergoodsShow = true
        },
        reviselogistics () { // 修改物流信息
            this.confirmrevise = false
            this.delivergoodsShow = true
            this.delivergoodsInfo.sendtime = this.orderinfo.sendtime
            this.delivergoodsInfo.returnfirm = this.orderinfo.returnfirm
            this.delivergoodsInfo.returnodd = this.orderinfo.returnodd
        },
        delivergoodsOk (e) { // 物流弹窗确认按钮
            if (this.confirmrevise) {
                this.http.post(api.delivergoods,
                    {
                        rebackid: this.$route.params.id,
                        sendtime: e.datetiem,
                        returnfirm: e.logistics,
                        returnodd: e.ordernum,
                    }
                )
                .then(response => {
                    this.$Message.success(response.data.msg)
                    this.getInfo()
                })
                .catch(error => {
                    this.$Message.warning(error)
                })
            } else {
                this.http.post(api.delivergoodsrevise,
                    {
                        rebackid: this.$route.params.id,
                        sendtime: e.datetiem,
                        returnfirm: e.logistics,
                        returnodd: e.ordernum,
                    }
                )
                .then(response => {
                    this.$Message.success(response.data.msg)
                    this.getInfo()
                })
                .catch(error => {
                    this.$Message.warning(error)
                })
            }
        },
        delivergoodsCancel () { // 关闭确认发货弹窗
            this.delivergoodsShow = false
        },
        uploadBefore () { // 上传文件之前
            const check = this.uploadList.length < 5;
            if (!check) {
                this.$Message.warning({
                    content: '最多上传5张'
                });
            }
            return check;
        },
        uploadProgress (event, file, fileList) { // 文件上传时
            console.log('上传时')
            console.log(event)
            console.log(file)
            console.log(fileList)
        },
        uploadSuccess (response, file, fileList) { // 文件上传成功
            console.log('上传成功')
            console.log(response)
            console.log(file)
            console.log(fileList)
            if (!response.error) {
                // file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
                // file.name = '7eb99afb9d5f317c912f08b5212fd69a';
                this.getInfo()
                this.$Message.success(file.name + '上传成功')
            } else {
                this.$Message.warning(response.msg)
            }
        },
        uploadError (error, file, fileList) { // 文件上传失败
            console.log('上传失败')
            console.log(error)
            console.log(file)
            console.log(fileList)
            this.$Message.error({
                content: fileList.name + '上传失败'
            })
        },
        uploadRemove (file, fileList) { // 文件列表移除文件时
            console.log('移除')
            console.log(file)
            console.log(fileList)
        },
        uploadExceededSize (file, fileList) { // 文件超出大小
            console.log('超出大小')
            console.log(file)
            console.log(fileList)
        },
        deluploadfile (file) { // 删除上传文件
            this.delupload(file)
            // const fileList = this.$refs.upload.fileList;
            // this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        },
        delupload (urls) { // 删除上传文件
            this.http.post(api.returndelupload,
                {
                    orderid: this.orderinfo.id,
                    file: urls
                }
            )
            .then(response => {
                console.log(response.data.msg)
                if (!response.data.error) {
                    this.$Message.success(response.data.msg)
                    this.getInfo()
                } else {
                    this.$Message.warning(response.data.msg)
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
    },
    watch: {
        sort (newVal, oldVal) {
            this.getInfo()
        }
    },
    filters: {
        moneyFilter (money) {
            return toMoney(money)
        }
    },
    created () {
        this.getInfo()
    },
    mounted () {
        // 获取上传列表
        this.uploadList = this.$refs.upload.fileList
    }
}
</script>

<style scoped>

.orderdetails_orderprice {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: 20px 0;
}

.orderdetails_orderprice > span {
    font-size: 16px;
    color: #333;
}

.orderdetails_orderprice > small {
    font-size: 16px;
    color: #FF3333;
}

.orderdetails_info_list > ul > li {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
}

.orderdetails_info_left {
    width: 84px;
    flex-grow: 0;
    flex-shrink: 0;
}

.orderdetails_info_left > span {
    font-size: 16px;
    color: #666;
    display: block;
}

.orderdetails_info_left > span.letter::first-letter {
    margin-right: 2em;
}

.orderdetails_info_right {
    flex-grow: 1;
    flex-shrink: 1;
}

.orderdetails_info_right > span {
    font-size: 16px;
    color: #333;
    display: block;
}

.orderdetails_info_right > small {
    margin-top: 1px;
    margin-right: 20px;
    font-size: 16px;
    color: #666;
    display: inline-block;
}

.orderdetails_info_content {
    padding: 10px 30px 26px 30px;
}

.edit {
    color: #FF8000;
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/views/order/returndetails.vue